import { wrapIfPresent } from '~/lib/wrapIfPresent'

export const getItemImageAlt = ({
  brandName,
  brandNameKana,
  itemName,
  categoryName,
  genderName,
  colorNames,
  sizeNames,
}: {
  brandName?: string
  brandNameKana?: string
  itemName: string
  categoryName: string
  genderName?: string
  colorNames?: string[]
  sizeNames?: string[]
}) => {
  const brandText = brandName
    ? `${brandName}${wrapIfPresent('（', brandNameKana, '）')}`
    : ''
  const itemInformationText = `（${[
    categoryName,
    genderName,
    colorNames?.join('/'),
    sizeNames?.join('/'),
  ]
    .filter(Boolean)
    .join('・')}）`

  if (!brandText) return `${itemName}${itemInformationText}`

  return `${brandText}の「${itemName}${itemInformationText}」`
}
